import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Person} from "../../../services/interface/query/person";
import {useFindDebtsAnt} from "../../../services/apis/apiDebts";
import NotPermissionComponent from "../NotPermissionComponent";
import CustomTable, {TypeItemTable} from "../../../components/general/CustomTable";
import {formatDateHoursString} from "../../../utils/daysOptions";
import {AntInterface} from "../../../services/interface/query/debs/ant-interface";
import {getMessageGeneric} from "../../../services/configuration/errorHandle";
import InfoOnline from "../../components/InfoOnline";

interface Props {
    person?: Person;
}
export default function Ant({person}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: findDebts,
        data: successDebts,
        error: errorDebts,
        isPending: loadingDebts,
    } = useFindDebtsAnt()

    const [response, setResponse] = useState<AntInterface[] | undefined>()
    const [listElement, setListElement] = useState<TypeItemTable[] | undefined>()

    useEffect(() => {
        if (person?.identification) {
            findDebts({identifier: person?.identification, msj: t('debts-ant')})
        }
    }, []);

    useEffect(() => {
        if (successDebts) {
            setResponse(successDebts)
        }
    }, [successDebts]);

    useEffect(() => {
        if (response && response.length > 0) {
            setListElement(response.map(item => ({
                row: [
                    item.type,
                    item.code,
                    item.entity,
                    item.additionalInfo,
                    item.plate,
                    formatDateHoursString(item.dateIssued),
                    formatDateHoursString(item.dateNotified),
                    item.points,
                    <span className={'flex justify-end font-light text-[12px]'}>{`$${item.amount ?? '-'}`}</span>,
                    item.description,
                ]
            })))
        }
    }, [response]);

    return (
        <div className={'flex flex-col gap-3'}>
            <div className={'flex flex-row gap-2'}>
                <h3>{t('debts-ant')}</h3>
                <InfoOnline onClick={() => {
                    if (person?.identification) {
                        findDebts({identifier: person?.identification, msj: t('debts-ant')})
                    }
                }}/>
            </div>
            <NotPermissionComponent
                title={'/debts/traffic_fine/ant'}
                loading={loadingDebts}
                error={errorDebts}
                component={
                    <>
                        <CustomTable
                            loading={loadingDebts}
                            error={getMessageGeneric(errorDebts, '/debts/traffic_fine/ant')}
                            header={[
                                t('type'),
                                t('infringement'),
                                t('entity'),
                                t('citation'),
                                t('plate-1'),
                                t('broadcast-date'),
                                t('registration-date'),
                                t('points'),
                                t('total'),
                                t('article'),
                            ]}
                            {...{listElement}}
                        />
                    </>
                }
            />
        </div>
    )
}
